import { useGql } from '#imports'
import { getSdk as defaultGqlSdk } from '#gql/default'
export const GqlSdks = {
  default: defaultGqlSdk,
}
export const GqClientOps = {"default":["Category","Entry","Job","NavigationsAndGlobals","Alternates","Asset","BlueprintCategory","BlueprintContentPage","BlueprintPage","ExclusiveReplicatorShopwareCategory","MainReplicatorShopwareCategory","ReplicatorComponents"]}
export const GqlCategory = (...params) => useGql()('Category', ...params)
export const GqlEntry = (...params) => useGql()('Entry', ...params)
export const GqlJob = (...params) => useGql()('Job', ...params)
export const GqlNavigationsAndGlobals = (...params) => useGql()('NavigationsAndGlobals', ...params)